import SectionLabel from "../common/SectionLabel";
import FactsList from "./FactsList";

function About() {
  return (
    <section id="about" className="divider">
      <div className="wrap">
        <SectionLabel label="about" />
        <div className="about-grid">
          <div className="about-text">
            <p>
              I'm a frontend developer in Toronto working mainly in React and
              TypeScript, with enough full-stack range to work the backend
              when a feature demands it. That's 2+ years in web development
              and 4+ live projects.
            </p>
            <p>
              At Plaiced I shipped 10+ features alongside four backend
              developers. Platform performance rose about 25%, bounce rate
              fell 18% and feature adoption grew 30%.
            </p>
            <p>
              On the full-stack side, I built Benefit Bridge solo at Hack the
              Hill III: describe your life in plain language and see which
              Canadian benefits you likely qualify for. AI extracts the
              facts, and a deterministic rules engine makes the call. At
              OracleLens I worked in JS/TS, Java and SQL on a commodity
              exchange platform ahead of its hard launch.
            </p>
            <p>
              Time as a Zoho consultant taught me that a feature nobody
              adopts is a failed feature. So I build with clean async
              states, accessible components and code that's still readable
              months later.
            </p>
          </div>
          <FactsList />
        </div>
      </div>
    </section>
  );
}

export default About;
